// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2ajdC","expireInfo":"styles_expireInfo__1MbO9","formContainer":"styles_formContainer__1K_Yu","registerUserForm":"styles_registerUserForm__QlAiG"};